module.exports = __webpack_public_path__ + "img/item3btn1.616d28b5.png";